// -- other --
import React,{useEffect,useState} from "react";
import {all_routes} from '../../router/all_routes'
import {Link,useNavigate} from "react-router-dom";
import ImageWithBasePath from '../../../core/img'
import series from 'async/series';
import {Toaster} from 'react-hot-toast';
// -- biz9 --
import {UrlQuery} from "biz9-react-utility";
import {Message,Type,Title,Project_Table} from "../../../constant";
import {Image,Style,User,Storage,System,Toast_Message,App} from "../../../project";
import {Store_Service,Cart_Logic,Store_Type,Order_Logic} from "biz9-store";
import {Response_Logic,Log,Num,Str,DateTime,Status_Type,Obj} from "biz9-utility";
import {User_Logic} from "biz9-user";
import {Image_Format} from "biz9-image";
import {Data_Logic} from "biz9-data-app";
import {Portal_Table,Portal_Remote_Store_Cart,Portal_Remote_Store_Order,Portal_Remote_Data,Portal_Url} from "biz9-portal-app";
const Product_App_Checkout_Success = () => {
    const query = UrlQuery();
    const navigate = useNavigate();
    const [product, setProduct] = useState(Data_Logic.get(Portal_Table.PRODUCT,0,{data:{product_type:"",delivery_time:"",sale_count:"",view_count:"",image_filename:''}}));
    const [user,setUser] = useState(User.get());
    const [cart,setCart] = useState(Data_Logic.get(Portal_Table.CART,0,{data:{grand_total:0,cart_items:[]}}));
    const [order,setOrder] = useState(Data_Logic.get(Portal_Table.ORDER,0,{data:{order_items:[]}}));
    const [order_payment,setOrderPayment] = useState(Data_Logic.get(Portal_Table.ORDER_PAYMENT,0,{data:{payment_method:"",payment_plan:"",payment_amount:"",transaction_id:"",payment_date:""}}));
    useEffect(() => {
            get_data();
            },[]);
    async function get_data() {
        // -- post-cart-order -- post-order-payment -- data-response --
        let response = Response_Logic.get();
        bind_items(Storage.get_order());
    };
    async function bind_items(data){
    setOrder(data);
    if(data.order_items.length>0){
        setProduct(data.order_items[0].parent);
    }
    if(data.order_payments.length>0){
        setOrderPayment(data.order_payments[0]);
    }
    };
return (
        <>
        <Toaster />
        {/* Breadcrumb */}
        <div className="breadcrumb-bar breadcrumb-bar-info">
        <div className="breadcrumb-img">
        <div className="breadcrumb-left">
        <ImageWithBasePath src="/assets/img/bg/banner-bg-03.png" alt="img" />
        </div>
        </div>
        <div className="container">
        <div className="row">
        <div className="col-md-12 col-12">
        <nav aria-label="breadcrumb" className="page-breadcrumb">
        <ol className="breadcrumb">
        <li className="breadcrumb-item">
        <Link to={all_routes.home}>Home</Link>
        </li>
        <li className="breadcrumb-item active" aria-current="page">
        Thank You
        </li>
</ol>
</nav>
<h2 className="breadcrumb-title mb-0">
Thank You <span className="text-primary" />
</h2>
</div>
</div>
</div>
</div>
{/* /Breadcrumb */}
{/* Page Content */}
<div className="page-content">
<div className="container">
{/* Received gigs */}
<div className="service-wrap text-center rounded-0 border-0 shadow-none p-0">
<div className="received-iocn mb-4 m-auto d-flex align-items-center justify-content-center">
<i className="ti ti-check" />
</div>
<h5 className="mb-1"> Thank you! Your order has been recieved. </h5>
<p>
{" "}
Order Number : <span> #{order.order_number} </span>{" "}
</p>
</div>
{/* Received gigs */}
{/* Order details */}
<div className="service-widget member-widget">
<h5 className="service-head d-flex align-items-center">
Order Details
</h5>
<div className="user-details bg-light p-3 mb-16">
<div  style={{display: !product.image_filename ? 'none' : 'block'}} className="user-img service-user">
<ImageWithBasePath   src={Image.get_url(product.image_filename,Image_Format.SQUARE_THUMB)}  alt="img" />
</div>
<div className="user-info">
<h5>
<span className="me-2">
{product.title}
</span>{" "}
</h5>
<p>Delivery Time: {product.delivery_time}</p>
<p>Payment Plan: {order[Type.PAYMENT_PLAN_TYPE]}</p>
</div>
</div>
<ul className="member-info">
{order.order_items.map((item) => (
            <>
            <li>{item.parent.title}
            <span>{Str.get_money(item.cost)}</span>
            </li>
            {item.order_sub_items.map((sub_item) => (
                        <li>
                        {sub_item.parent.type}{" "}{sub_item.parent.category}{":"}{sub_item.parent.title}
                        <span>{Str.get_money(sub_item.cost)}</span>
                        </li>
                        ))}
            </>

            ))}
</ul>
<div className="about-me m-0 pt-3 mt-3 border-top border-grey">
<h6 className="d-flex justify-content-between align-items-center m-0">
Total <span> {Str.get_money(order.grand_total)}</span>
</h6>
</div>
</div>
{/* Order details */}
{/* Billing details */}
<div className="row">
<div className="col-lg-12">
<div className="service-widget">
<h5 className="service-head mb-3">Billing Information </h5>
<h6 className="mb-2">{user.title}</h6>
<div className="service-text">
<p className="mb-1">
{User_Logic.get_country_state_city(user)}
</p>
<p className="mb-0">Email ID : {user.email}</p>
</div>
</div>
</div>
<div className="col-lg-12">
<div className="service-widget m-0">
<h5 className="service-head mb-3">Payment Details </h5>

<div className="d-flex align-items-center justify-content-between flex-wrap gap-3">

<div className="service-text mb-0">
<h6 className="mb-1">Payment Method</h6>
<p className="mb-0"> {order_payment.payment_method_type} </p>
</div>

<div className="service-text mb-0">
<h6 className="mb-1">Payment Plan</h6>
<p className="mb-0"> {order.payment_plan_type} </p>
</div>


<div className="service-text mb-0">
<h6 className="mb-1">Payment Amount</h6>
<p className="mb-0"> {Str.get_money(order_payment.payment_amount)}</p>
</div>


<div className="service-text mb-0">
<h6 className="mb-1">Transaction ID</h6>
<p className="mb-0">#{order_payment.transaction_id}</p>
</div>

<div className="service-text mb-0">
<h6 className="mb-1">Time &amp; Date</h6>
<p className="mb-0">{DateTime.get_date_time(order_payment.payment_date)}</p>
</div>

</div>
</div>
</div>
</div>
{/* Billing details */}
</div>
</div>
{/* Page Content */}
</>
)
}

export default Product_App_Checkout_Success
